import styled from 'styled-components';
import PodStatus from './PodStatus';
import { colorSchema } from 'utils/style';

export default styled(PodStatus)`
  .pod-status {
    border-bottom: 1px solid ${colorSchema('grey200')};
    display: flex;
    flex-direction: column;
    padding: 1.6rem 0;

    &__title {
      color: ${colorSchema('grey700')};
      font-size: 1.4rem;
      margin-bottom: 0.8rem;
    }

    &__document {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.8rem;

      &:last-of-type {
        margin: 0;
      }
    }

    &__company-name {
      color: ${colorSchema('grey900')};
      font-size: 1.6rem;
      font-weight: 500;
      margin-right: 1rem;
    }

    &__container {
      margin-bottom: 1.6rem;
    }

    &__upload {
      width: 100%;
    }
  }
`;
